module.exports = __webpack_public_path__ + "assets/img/landing-rtb-hero.22963cb4.jpg";